
export const CONFIG = {
  modules: {
    // accounts: {
    //   host: `${process.env.REACT_APP_HOST}:2930/api/accounts`,
    //   socket: `${process.env.REACT_APP_HOST}:2930/`,
    // },
    // crm: {
    //   host: `${process.env.REACT_APP_HOST}:2931/api/crm`,
    //   socket: `${process.env.REACT_APP_HOST}:2931/`,
    // },
    accounts: {
      host: `${process.env.REACT_APP_HOST_ACCOUNTS}/api/accounts`,
      socket: `${process.env.REACT_APP_HOST_ACCOUNTS}/`,
    },
    crm: {
      host: `${process.env.REACT_APP_HOST_CRM}/api/crm`,
      socket: `${process.env.REACT_APP_HOST_CRM}/`,
    },
  },
};

